import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../../hooks'
import { FormikField } from '../../../../../Formik'
import { InputField } from '../../../../../Input'
import { USER_FORM_FIRST_NAME_FIELD_MAX_LENGTH } from '../../../../../User'
import { APPLICANT_FORM_FIELD_NAME_FIRST_NAME } from '../../RentalPortalApplicantForm.constants'

function FirstNameField({ fieldRef }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      autoFocus
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      elementRef={fieldRef}
      fieldComponentProps={{
        label: `${t('Inhabitant.FirstNameLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={USER_FORM_FIRST_NAME_FIELD_MAX_LENGTH}
      name={APPLICANT_FORM_FIELD_NAME_FIRST_NAME}
      placeholder={t('Inhabitant.FirstNamePlaceholderKey')}
    />
  )
}

export default FirstNameField
